export default "__VITE_ASSET__B5qvw2vo__"